export default "__VITE_ASSET__DqyApmAZ__"